import { captureException } from '@sentry/react';
import { useCallback, useEffect, useRef, useState } from 'react';

export const useCopyToClipboard = () => {
  const [isCopied, setIsCopied] = useState(false);
  const resetTimeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => () => clearTimeout(resetTimeoutRef.current), []);

  const copy = useCallback(
    async (text: string) => {
      if (isCopied || !navigator.clipboard) return;

      try {
        await navigator.clipboard.writeText(text);
        setIsCopied(true);
        resetTimeoutRef.current = setTimeout(() => setIsCopied(false), 2500);
      } catch (error) {
        captureException(new Error('Failed to write to clipboard', { cause: error }), { level: 'error' });
      }
    },
    [isCopied],
  );

  return [isCopied, copy] as const;
};
